import { TypedDocumentNode, gql } from '@apollo/client';
import { CSSProperties } from 'react';
import styled from 'styled-components';

import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { usePreferredLineupStyle } from '@sorare/gameplay/src/components/lineup/LineupStyleSwitch';
import {
  LineupLayout as GenericLineupLayout,
  Props as GenericLineupLayoutProps,
} from '@sorare/gameplay/src/layouts/LineupLayout';

import { NbaLineupLayout_so5LeaderboardContender } from './__generated__/index.graphql';
import field from './assets/field.jpg';

const Root = styled.div`
  /**
  * --current-stack-height doesn't work here because the hash scroll happens
  * before the measure has time to finish and updating scroll-margin-top value
  * after the scroll happened is a no-op
  */
  scroll-margin-top: calc(var(--navbar-height-mobile) + 60px);
  @media ${desktopAndAbove} {
    scroll-margin-top: calc(var(--navbar-height-desktop) + 88px);
  }
`;
const StyledLineupLayout = styled(GenericLineupLayout)`
  &:before {
    content: '';

    position: absolute;
    inset: 0;

    background-image: var(--bg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 25%;
    background-color: var(--c-neutral-100);
  }
`;

type Props = GenericLineupLayoutProps & {
  so5LeaderboardContender: NbaLineupLayout_so5LeaderboardContender;
};

export const LineupLayout = ({ so5LeaderboardContender, ...props }: Props) => {
  const [lineupStyle] = usePreferredLineupStyle();
  return (
    <Root id={so5LeaderboardContender.slug}>
      <StyledLineupLayout
        rankingOnTop={lineupStyle === 'inline'}
        style={
          {
            '--bg': `url(${so5LeaderboardContender.so5Leaderboard.so5LeaderboardGroup.stadiumUrl || field})`,
          } as CSSProperties
        }
        so5LeaderboardContender={so5LeaderboardContender}
        {...props}
      />
    </Root>
  );
};

LineupLayout.fragments = {
  so5LeaderboardContender: gql`
    fragment NbaLineupLayout_so5LeaderboardContender on So5LeaderboardContender {
      slug
      so5Leaderboard {
        slug
        so5LeaderboardGroup {
          slug
          stadiumUrl
        }
      }
      ...LineupLayout_so5LeaderboardContender
    }
    ${GenericLineupLayout.fragments.so5LeaderboardContender}
  ` as TypedDocumentNode<NbaLineupLayout_so5LeaderboardContender>,
};
